import { createSelector } from 'reselect';

import { getLocationPointAreaId } from '@commons/models/LocationPoint';

import getSearchedLocation from './getSearchedLocation';

const getSearchedLocationAreaId = createSelector(
  getSearchedLocation,
  location => getLocationPointAreaId(location),
);

export default getSearchedLocationAreaId;
